import { ExclamationCircleOutlined, FileExclamationOutlined, LoadingOutlined } from '@ant-design/icons';
import {
  Alert, Button, Popconfirm, Tag,
} from 'antd';
import React from 'react';
import './style.scss';
import Helpers from '@Apis/helpers';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const PushIRPButtons = ({
  user,
  selectedInvoice, pushIRPLoading, pushIRP, type, tagValue, tagColor, message, iconColor,
}) => (
  <React.Fragment>
    <Alert
      className="e-invoice-alert-null"
      message={(
        <React.Fragment>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div>
              <div>
                <span>
                  <FileExclamationOutlined
                    style={{
                      color: `${iconColor}`,
                      marginRight: '5px',
                    }}
                  />
                  {' '}
                </span>
                e-Invoice
                {' '}
                <Tag color={tagColor}>{tagValue}</Tag>
                {' '}
                {message}
              </div>
              { selectedInvoice?.e_invoice_errors?.length > 0 && selectedInvoice?.e_invoice_errors[0]?.length > 0
        && (
          <div>
            <div className="e-invoice-error-messages">

              {selectedInvoice?.e_invoice_errors?.map((error, index) => (
                <div
                  key={index}
                  className="e-invoice-error-message"
                  style={{
                    backgroundColor: '#fff1f0',

                  }}
                >
                  <span>
                    <ExclamationCircleOutlined
                      style={{
                        color: '#ff4d4f',
                        marginRight: '5px',
                      }}
                    />
                    {' '}
                  </span>
                  {error}
                </div>
              ))}
            </div>
          </div>
        )}
            </div>
            {Helpers.getPermission(Helpers.permissionEntities.E_INVOICE, Helpers.permissionTypes.UPDATE, user) && (
              <Popconfirm
                title="Push to IRP"
                description="Are you sure you want to push the document to IRP?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => pushIRP()}
                disabled={pushIRPLoading}
              >
                <div
                  className="push-to-irp__button"
                >
                  {pushIRPLoading ? <LoadingOutlined /> : 'Push to IRP'}
                </div>
              </Popconfirm>
            )}
          </div>
        </React.Fragment>
      )}
      type={type}
    />

  </React.Fragment>
);
const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
});
PushIRPButtons.propTypes = {
  user: PropTypes.any,
  iconColor: PropTypes.any,
  selectedInvoice: PropTypes.string,
  pushIRPLoading: PropTypes.bool,
  pushIRP: PropTypes.func,
  type: PropTypes.string,
  tagValue: PropTypes.string,
  tagColor: PropTypes.string,
  message: PropTypes.string,

};

export default connect(mapStateToProps)(withRouter(PushIRPButtons));
